import React from 'react';
import { Routes, Route } from 'react-router-dom';

// pages
import ElectionPeriod from './ElectionPeriod';
import OtherCoverage from './OtherCoverage';
import LTCF from './LTCF';
// import Language from './Language';
// import RaceEthnicity from './RaceEthnicity';
import CSNP from './CSNP';
// import Veteran from './Veteran';
import EmbeddedBenefits from './EmbeddedBenefits';

function Eligibility() {
  return (
    <Routes>
      <Route path="election-period" element={<ElectionPeriod />} />
      <Route path="other-coverage" element={<OtherCoverage />} />
      <Route path="ltcf" element={<LTCF />} />
      {/* <Route path="language" element={<Language />} /> */}
      {/* <Route path="race-ethnicity" element={<RaceEthnicity />} /> */}
      <Route path="csnp" element={<CSNP />} />
      {/* <Route path="veteran" element={<Veteran />} /> */}
      <Route path="embedded-benefits" element={<EmbeddedBenefits />} />
    </Routes>
  );
}

export default Eligibility;
